module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"eventsCategoriesFormNameLabel":"Name (*)","eventsCategoriesFormNamePlaceholder":"Enter a name","eventsCategoriesFormNameError":"Name is a required field"},"no":{"eventsCategoriesFormNameLabel":"Navn (*)","eventsCategoriesFormNamePlaceholder":"Skriv et navn","eventsCategoriesFormNameError":"Navn er et påkrevd felt"}}')
  delete Component.options._Ctor
}
